import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "@lhd/libs/axios";
import {
  ERRORS_MESSAGE,
  QUERY_NAME,
  SERVICES,
  SUCCESSFUL_MESSAGE,
} from "@lhd/constants";
import { notification } from "antd";
import { getCompanyId } from "@lhd/utility";

export const useUploadMultipleMedia = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (files: File[]) => {
      const formData = new FormData();
      files.forEach((file: File) => {
        formData.append("attachments[][file]", file);
      });
      return axios({
        method: "post",
        data: formData,
        url: `${SERVICES.UPLOAD_MULTIPLE_MEDIA}`,
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "application/json",
        },
      });
    },
    {
      onSuccess() {
        queryClient.invalidateQueries([QUERY_NAME.UPLOAD_MULTIPLE_MEDIA]);
        notification["success"]({
          message: "保存しました",
        });
      },
    },
  );
};

export const useUploadSingleMedia = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (file: File) => {
      const formData = new FormData();
      formData.append("file", file);
      return axios({
        method: "post",
        data: formData,
        url: `${SERVICES.UPLOAD_SINGLE_MEDIA}`,
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "application/json",
        },
      });
    },
    {
      onSuccess() {
        queryClient.invalidateQueries([QUERY_NAME.UPLOAD_SINGLE_MEDIA]);
        notification["success"]({
          message: SUCCESSFUL_MESSAGE.UPLOAD_SUCCESSFUL,
        });
      },
      onError() {
        notification["error"]({
          message: ERRORS_MESSAGE.UPLOAD_FAILED,
        });
      },
    },
  );
};

export const useUploadSingleVideo = (courseId?: string) => {
  const queryClient = useQueryClient();

  return useMutation(
    (file: File) => {
      const formData = new FormData();
      formData.append("file", file);
      return axios({
        method: "post",
        data: formData,
        url: `${SERVICES.UPLOAD_SINGLE_VIDEO}`,
        params: {
          company_id: getCompanyId(),
          course_id: courseId ?? null,
        },
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "application/json",
        },
      });
    },
    {
      onSuccess() {
        queryClient.invalidateQueries([QUERY_NAME.UPLOAD_SINGLE_MEDIA]);
        notification["success"]({
          message: SUCCESSFUL_MESSAGE.UPLOAD_SUCCESSFUL,
        });
      },
      onError() {
        notification["error"]({
          message: ERRORS_MESSAGE.UPLOAD_FAILED,
        });
      },
    },
  );
};
